export interface IAnswer {
  candidate_id: number
  tunnus_id?: string
  question_id: number
  answer?: number
  explanation?: string | null
}

export interface IAnswerOption {
  id: number
  text: string
}

export const answerOptions: IAnswerOption[] = [
  {id: 1, text: 'Täysin eri mieltä'},
  {id: 2, text: 'Eri mieltä'},
  {id: 3, text: 'Neutraali'},
  {id: 4, text: 'Samaa mieltä'},
  {id: 5, text: 'Täysin samaa mieltä'}
]
